import React from 'react';
import moment from 'moment';
import numberFormatter from '../../../utils/numberFormatter.js'
import QueryStringService from '../../../services/queryStringService.js'
import PanelService from '../../../services/panelService';
import * as consts from '../../../models/consts.js'
import IDSCalculator from '../../../calculators/ids_calculator.js';

export default class CampaignDetailsPlayLocalParam5 extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
    }

    render() {
        let spotlengthText = '';
        let asterix = '*';
        let showPromisedScreens = false;
        let showPromisedSOV = false;
        let vac = this.props.selectedDetailsData.totalVAC;

        // captions
        let promisedScreensCaption = "Promised screens";
        let deliveredVACCaption = "EA-VAC";
        let alternativeDeliveredVACCaption = "EA-VAC";

        // buttons
        let showDeliveredScreensInIDS = false;
        let showDeliveredVAC = true;
        let showDeliveredSOV = false;
        let showDeliveredReach = false;
        let showDeliveredFrequency = false;

        let idsReachValue = 0;
        let idsAverageFrequencyValue = 0;

        switch (this.props.campaignPackagePromise) {
            case consts.CampaignPromisePackings.sovp:
                showPromisedScreens = true;
                break;
            case consts.CampaignPromisePackings.sfi:
                showDeliveredVAC = false;
                break;
            case consts.CampaignPromisePackings.fxp:
                showDeliveredSOV = true;
                showPromisedScreens = true;
                promisedScreensCaption = "Screens";
                break;
            case consts.CampaignPromisePackings.sov:
                showPromisedScreens = true;
                showPromisedSOV = true;
                showDeliveredReach = true;
                showDeliveredFrequency = true;
                deliveredVACCaption = "VAC";

                vac = this.props.campaignInfo.idsVac;
                idsReachValue = this.props.campaignInfo.idsReach
                idsAverageFrequencyValue = this.props.campaignInfo.idsAverageFrequency
                if (this.props.campaignInfo.idsImportedValuesFromExcel !== null) {
                    const IDSNationalValues = IDSCalculator.caluclateIDS_ReachAndFrequencyNationalValues(this.props.campaignInfo.idsImportedValuesFromExcel,
                        this.props.campaignInfo.periodEnd, this.props.parameters.clientSettings.idsUseNationalStart);

                    if (IDSNationalValues['Reach'] !== 0 || IDSNationalValues['Frequency'] !== 0) { 
                        idsReachValue = IDSNationalValues['Reach'];
                        idsAverageFrequencyValue = IDSNationalValues['Frequency'];
                    }
                }
                break;
        }

        if (this.props.spotlength === 'mixed'){
            spotlengthText = 'Mixed (' + this.props.selectedDetailsData.spotlengths.join(', ') + ')';
        }
        else if (this.props.spotlength !== ''){
            spotlengthText = this.props.selectedDetailsData.spotlengths[0];
        }
        return (
            <div className="campaign-details">
                <div className="row">
                    <div className="col-md-7" style={{ 'paddingBottom': '20px', 'minWidth': '280px' }}>
                        <h4 style={{ marginTop: '0px', marginBottom: '6px' }}>Campaign Details</h4>
                        <table>
                            <tbody>
                                <tr>
                                    <th>Product</th>
                                    <td>{this.props.selectedOrderLines[0].product}</td>
                                </tr>
                                <tr>
                                    <th>Campaign name</th>
                                    <td>{this.props.campaignName}</td>
                                </tr>
                                <tr>
                                    <th>{'Period'}<br/>{(this.props.periodManuallySelected ? ' (manually selected)' :'') }</th>
                                    <td>{moment(this.props.selectedDetailsData.startDate).format('YYYY-MM-DD')}<br />{moment(this.props.selectedDetailsData.endDate).format('YYYY-MM-DD')}</td>
                                </tr>
                                {showPromisedSOV &&
                                    <tr>
                                        <th>Promised SOV %</th>
                                        <td>{numberFormatter.numberWithOneDecAndProcent(this.props.selectedOrderLines[0].targetSoV)}</td>
                                    </tr>
                                }
                                {showPromisedScreens &&
                                    <tr>
                                        <th>{promisedScreensCaption}</th>
                                        <td>{numberFormatter.numberWithSpaces(this.props.selectedOrderLines[0].targetScreens)}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-5" style={{ 'minWidth': '240px' }}>
                        <h4 style={{marginTop: '0px', marginBottom: '6px'}}>Playout</h4>
                        <table>
                            <tbody>
                                {showDeliveredVAC &&
                                    <tr>
                                        <th>{deliveredVACCaption} {asterix}</th>
                                        <td>{numberFormatter.numberWithSpaces(vac)}</td>
                                    </tr>
                                }
                                {showDeliveredReach &&
                                    <tr>
                                        <th>Reach</th>
                                        <td>{numberFormatter.numberWithSpaces(idsReachValue)}</td>
                                    </tr>
                                }
                                {showDeliveredFrequency &&
                                    <tr>
                                        <th>Frequency</th>
                                        <td>{numberFormatter.numberWithSpaces(idsAverageFrequencyValue)}</td>
                                    </tr>
                                }
                                <tr>
                                    <th>Spot length</th>
                                    <td>{spotlengthText} sec</td>
                                </tr>
                                <tr>
                                    <th>Plays</th>
                                    <td>{numberFormatter.numberWithSpaces(this.props.campaignInfo.plays)}</td>
                                </tr>
                                {showDeliveredSOV &&
                                    <tr>
                                        <th>SOV %</th>
                                        <td>{numberFormatter.numberWithOneDecAndProcent(this.props.campaignInfo.soV)}</td>
                                    </tr>
                                }
                                <tr>
                                    <th>Screens</th>
                                    <td>{numberFormatter.numberWithSpaces(this.props.campaignInfo.notStarted ? 0 : this.props.campaignInfo.screens)}</td>
                                </tr>
                                {showDeliveredScreensInIDS &&
                                    <tr>
                                        <th>Screens in IDS</th>
                                        <td>{numberFormatter.numberWithSpaces(PanelService.getIDSPanels(this.props.selectedData.panels).length)}</td>
                                    </tr>
                                }
                                {this.country !== consts.Countries.no && this.props.useAlternateContacts && this.props.spotlength === 10 &&
                                    <tr>
                                        <th>{alternativeDeliveredVACCaption} (10 sec)</th>
                                        <td>{numberFormatter.numberWithSpaces(this.props.selectedDetailsData.totalAlternateVAC)}</td>
                                    </tr>
                                }
                                {this.country == consts.Countries.no && this.props.useAlternateContacts && this.props.spotlength === 5 &&
                                    <tr>
                                        <th>{alternativeDeliveredVACCaption} (5 sec)</th>
                                        <td>{numberFormatter.numberWithSpaces(this.props.selectedDetailsData.totalAlternateVAC)}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}